import { ReactNode } from "react";
import styled from "styled-components";
import { Logo } from "../../assets/svg/Svgs";
import {
  APP_BAR_HEIGHT,
  APP_NAME,
  LEFT_MENU_WIDTH,
  TAGLINE,
} from "../../constants/constants";
import { AppBar } from "../common/AppBar";
import BottomNavBar from "../common/BottomNavBar";
import { LeftMenu } from "../menus/LeftMenu";

export const DashboardLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="vh100 hidden flexColumn">
      <AppBar />
      <ContentWrapper className="y100 flex hidden">
        {/* LEFT */}
        <LeftMenu />

        {/* MAIN */}
        <MainWrapper className="y100 scroll flexGrow">
          <ChildWrapper>
            {/* CHILDREN */}
            {children}
            {/* PLACEHOLDER */}
            <div
              className="dotBg r20 flexCenter whiteBg"
              id="placeholderOverlay"
            >
              <div className="textCenter">
                <img width={70} src={Logo} alt={APP_NAME} />
                <div className="textDark bold font16">{APP_NAME}</div>
                <div className="grey font12">{TAGLINE}</div>
              </div>
            </div>
          </ChildWrapper>
        </MainWrapper>
      </ContentWrapper>
      <BottomNavBar />
    </div>
  );
};

const ContentWrapper = styled.div`
  margin-top: ${APP_BAR_HEIGHT};

  @media (max-width: 960px) {
    margin-bottom: ${APP_BAR_HEIGHT};
  }
`;

const MainWrapper = styled.div`
  margin-left: ${LEFT_MENU_WIDTH};
  @media (max-width: 960px) {
    margin: 0;
  }
`;

const ChildWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    #placeholderOverlay {
      display: none;
    }
  }
`;
